var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 20,
    viewBox: "0 0 53 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2950_68062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8972 0C48.4102 0 52.881 4.4781 52.881 10C52.881 15.5219 48.4102 20 42.8972 20H10.1029C4.58998 20 0.119141 15.5219 0.119141 10C0.119141 4.4781 4.58998 0 10.1029 0H42.8972Z",
    fill: "#00DE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1191 17.249C6.11532 17.249 2.86963 14.0033 2.86963 9.99952C2.86963 5.99571 6.11532 2.75 10.1191 2.75C14.1229 2.75 17.3687 5.99571 17.3687 9.99952C17.3706 14.0033 14.1248 17.249 10.1191 17.249ZM11.5191 6.37286V10.3595L8.71725 6.37286H6.49437V13.6224H8.72106V9.63573L11.5229 13.6224H13.7458V6.37286H11.5191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0065 5.39399L43.8579 10.3197L41.4846 5.39399H39.317L42.9094 12.3845L41.4655 15.6226H43.5132L48.0522 5.39399H46.0065ZM36.2941 13.2321H38.2351V5.39208H36.2941V6.03589C35.6274 5.49875 34.8732 5.21875 33.9589 5.21875C31.7513 5.21875 30.0217 7.03208 30.0217 9.31018C30.0217 11.5883 31.7513 13.4016 33.9589 13.4016C34.8732 13.4016 35.6274 13.1216 36.2941 12.5845V13.2321ZM34.2408 11.8149C32.9417 11.8149 31.9646 10.7407 31.9646 9.31399C31.9646 7.88732 32.9436 6.81304 34.2408 6.81304C35.5379 6.81304 36.517 7.88732 36.517 9.31399C36.5189 10.7387 35.5398 11.8149 34.2408 11.8149ZM22.8103 12.6264C23.4636 13.1388 24.1951 13.4054 25.077 13.4054C27.2846 13.4054 29.0141 11.5921 29.0141 9.31399C29.0141 7.03589 27.2846 5.22256 25.077 5.22256C24.1627 5.22256 23.4084 5.50256 22.7417 6.0397V5.39589H20.8008V15.6245H22.8084V12.6264H22.8103ZM22.5189 9.31399C22.5189 7.88732 23.4979 6.81304 24.7951 6.81304C26.0922 6.81304 27.0713 7.88732 27.0713 9.31399C27.0713 10.7407 26.0922 11.8149 24.7951 11.8149C23.4979 11.8149 22.5189 10.7387 22.5189 9.31399Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2950_68062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7619,
    height: 20,
    fill: "white",
    transform: "translate(0.119141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNpay);
export default __webpack_public_path__ + "static/media/icon-npay.ac3222c36f790f6fb793ba8c7c75847e.svg";
export { ForwardRef as ReactComponent };